import { render, staticRenderFns } from "./BaseAsyncSelect.vue?vue&type=template&id=b8395446&scoped=true"
import script from "./BaseAsyncSelect.vue?vue&type=script&lang=js"
export * from "./BaseAsyncSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseAsyncSelect.vue?vue&type=style&index=0&id=b8395446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8395446",
  null
  
)

export default component.exports